import { useState } from 'react';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

import { useDatePickerInput, UseDatePickerInputArgs, useSelectSingle } from '@foradevelopment/fora-ui';
import { FAGroupViewModel, MarkupNew } from '@fora-monorepo/employer-my-pages-common/types';
import { trackTrace } from '@fora-monorepo/webapp-analytics';

import { MarkupForm } from '../ManageEmployment';

type MarkupEditProps = {
  onSubmit: ({
    fokId,
    startDate,
    fokText,
    faGroupId,
  }: {
    fokId: string;
    startDate: string;
    fokText: string;
    faGroupId: string;
  }) => void;
  onCancel: () => void;
  markupOptions: FAGroupViewModel[];
  selectedMarkup: Omit<MarkupNew, 'status'>;
  markupDatePickerInputSettings: UseDatePickerInputArgs;
  editable: boolean;
  ffFaGroupIdOnEmployment: boolean;
};

export const MarkupEdit = ({
  markupOptions,
  markupDatePickerInputSettings,
  onSubmit,
  onCancel,
  selectedMarkup,
  editable,
  ffFaGroupIdOnEmployment,
}: MarkupEditProps) => {
  const markupSelectInput = useSelectSingle(ffFaGroupIdOnEmployment ? selectedMarkup.faGroupId : selectedMarkup.fokId);
  const markupStartDateInput = useDatePickerInput({
    ...markupDatePickerInputSettings,
    initValue: selectedMarkup.startDate,
  });

  const matchingMarkupOption = markupOptions.find(
    o => (ffFaGroupIdOnEmployment ? o.faGroupId : o.fokId) === markupSelectInput.props.value
  );

  const handleSubmit = () => {
    const markupStartDateValidationErrors = markupStartDateInput.validateDateInputValue();

    if (markupSelectInput.validate() && !markupStartDateValidationErrors.length && matchingMarkupOption) {
      onSubmit({
        startDate: markupStartDateInput.value,
        fokText: matchingMarkupOption.fokText,
        faGroupId: matchingMarkupOption.faGroupId,
        fokId: matchingMarkupOption.fokId,
      });
    } else {
      trackTrace(
        `Selected markup ${markupSelectInput.props.value} is not available in markupOptions`,
        SeverityLevel.Warning
      );
    }
  };

  return (
    <MarkupForm
      markupOptions={markupOptions}
      startDateInputProps={markupStartDateInput.props}
      startDateInputValue={markupStartDateInput.value}
      markupSelectInput={markupSelectInput}
      selectedMarkup={selectedMarkup}
      formType="add"
      onSubmit={handleSubmit}
      onCancel={onCancel}
      editable={editable}
      ffFaGroupIdOnEmployment={ffFaGroupIdOnEmployment}
    />
  );
};
